import { render } from "./TablaTotalesCentro.vue?vue&type=template&id=806dce6e"
import script from "./TablaTotalesCentro.vue?vue&type=script&lang=js"
export * from "./TablaTotalesCentro.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__